import { render } from "./AddInsurancePage.vue?vue&type=template&id=6d07e6ac&scoped=true"
import script from "./AddInsurancePage.vue?vue&type=script&lang=js"
export * from "./AddInsurancePage.vue?vue&type=script&lang=js"

import "./AddInsurancePage.vue?vue&type=style&index=0&id=6d07e6ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d07e6ac"]])

export default __exports__